'use client'

import React, { useEffect, useState } from 'react'
import { useGetReviewsProductMutation } from '@/shared/api-rtk/index.js'
import DescriptionChapter from '@/entities/catalog-inside-page/DescriptionChapter'
import { useInView } from 'react-intersection-observer'
import ReviewsChapter from '@/entities/catalog-inside-page/ReviewsChapter/index.js'
import FaqChapter from '@/entities/catalog-inside-page/FaqChapter/index.js'
import BlogChapter from '@/entities/catalog-inside-page/BlogChapter/index.js'
import { TOAST_ERROR } from '@/shared/constants/toastTypes.js'

const menuItems = ['Описание', 'Отзывы', 'Вопросы', 'Статьи']
export const TabBarNav = ({ product, productId }) => {
    const [showContent, setShowContent] = React.useState(menuItems[0])
    const [getReviews] = useGetReviewsProductMutation()

    const [reviews, setReviews] = useState([])
    const { inView, ref } = useInView({
        threshold: 0,
        triggerOnce: true,
    })

    useEffect(() => {
        getReviews(productId)
            .unwrap()
            .then((res) => {
                if (res.result === 'success') {
                    setReviews(Object.values(res.data).reverse())
                }
            })
            .catch(() => TOAST_ERROR('Не удалось получить отзывы'))
        getReviews(productId)
    }, [productId])

    return (
        <div
            ref={ref}
            className={`TabBarNav ${
                inView && 'animate__animated animate__fadeIn'
            }`}
        >
            <nav>
                {menuItems.map((itemMenu, index) => {
                    const hasReviews = itemMenu === 'Отзывы'
                    return (
                        <button
                            key={index}
                            disabled={showContent === menuItems[index]}
                            onClick={() => setShowContent(menuItems[index])}
                        >
                            {menuItems[index]}
                            <span>{hasReviews && ` (${reviews.length})`}</span>
                        </button>
                    )
                })}
            </nav>
            <main className={'content-item'}>
                {showContent === menuItems[0] && (
                    <DescriptionChapter
                        productDescription={product.description}
                    />
                )}
                {showContent === menuItems[1] && (
                    <ReviewsChapter
                        product={{ productId, productName: product.name }}
                        reviews={reviews}
                    />
                )}
                {showContent === menuItems[2] && (
                    <FaqChapter
                        productId={productId}
                        productName={product.name}
                    />
                )}
                {showContent === menuItems[3] && (
                    <BlogChapter productId={productId} />
                )}
            </main>
        </div>
    )
}
